import * as customers from './customers'
import * as campaigns from './campaigns'
import * as recipients from './recipients'
import * as table from './table'
import * as ui from './ui'

const thunkActions = { ...customers, ...campaigns, ...recipients, ...table, ...ui };
export default thunkActions;
